var notification = {
    config: {
        infoAction: true,
        offset: {x: 0, y: 140},
        error: {
            icon: 'glyphicon glyphicon-exclamation-sign',
            duration: 10000,
            type: 'danger'
        },
        inputError: {
            icon: 'glyphicon glyphicon-warning-sign',
            type: 'warning',
            duration: 5000,
        },
        warning: {
            icon: 'glyphicon glyphicon-warning-sign',
            type: 'warning',
            duration: 5000,
        },
        result: {
            icon: 'glyphicon glyphicon-check',
            type: 'success',
            duration: 3000,
        },
        info: {
            icon: 'glyphicon glyphicon-info-sign',
            type: 'info',
            duration: 3000,
        }
    },
    system: {
        messages: {},
        addToQue: function (type, message, handler) {
            if (!message) return;
            if (!Object.prototype.hasOwnProperty.call(this.messages, type)) {
                this.messages[type] = [{msg: message, act: handler}];
            } else if (!this.messages[type].find(function (x) {
                return x.msg == message;
            })) {
                this.messages[type].push({msg: message, act: handler});
            }
        },
        runTimeCall: function (type, message, handler) {
            if (!this.isLoading()) {
                this.showMsg(type, message, handler)
            }
            this.addToQue(type, message, handler);
            this.updateCounter();
        },
        isLoading: function () {
            return !jQuery.isReady
        },
        showMsg: function (type, message, handler) {
            if (!message) return;
            $.notify({
                icon: notification.config[type].icon,
                message: message
            }, {
                offset: notification.config.offset,
                delay: notification.config[type].duration,
                onClick: handler,
                type: notification.config[type].type
            });
            // set the timer so we know we are showint infos atm.
            notification.config.infoAction = false;
            setTimeout(function () {
                notification.config.infoAction = true;
            }, notification.config[type].duration);
        },
        showBuffedMessages: function () {
            if (Object.keys(notification.system.messages).length > 0) {
                $.each(notification.system.messages, function (type, entries) {
                    if (type && entries.length > 0)
                        $.each(entries, function (id, message) {
                            notification.system.showMsg(type, message.msg, message.act);
                        })
                });
            }
            this.updateCounter()
            return false; //compatibility with sap systems
        },
        getMessageCount: function () {
            var counter = 0;
            $.each(notification.system.messages, function (type, entries) {
                counter += entries.length;
            })
            return counter;
        },
        updateCounter: function () {
            $('#badge-global-notifications').removeClass("toggle-visibility").html(this.getMessageCount());
        }


    },
    promptCustom: function (question, content, callback, yesText, noText) {
        vex.defaultOptions.className = 'vex-theme-top';
        vex.dialog.buttons.YES.text = yesText ? yesText : output['t_ja'];
        vex.dialog.buttons.NO.text = noText ? noText : output['t_nein'];
        vex.dialog.prompt({
            message: question,
            input: content,
            callback: function (value) {
                if (value !== false) {
                    callback(value)
                }
            }
        })
        return false; //compatibility with sap systems
    },
    promptCustomYesNo: function (question, content, yesText, noText, callback, fail) {
        vex.defaultOptions.className = 'vex-theme-top';

        vex.dialog.open({
            message: question,
            input: content,
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: yesText
                }),
                $.extend({}, vex.dialog.buttons.NO, {
                    text: noText
                })
            ],
            callback: function (value) {
                if (value !== false) {
                    callback(value);
                } else if (typeof fail === 'function') {
                    fail(value);
                }
            }
        });
        return false; // compatibility with SAP systems
    }
};
notification.error = function (message, handler) {
    this.system.runTimeCall('error', message, handler);
}
notification.warning = function (message, handler) {
    this.system.runTimeCall('warning', message, handler);
}
notification.result = function (message, handler) {
    this.system.runTimeCall('result', message, handler);
}
notification.info = function (message, handler) {
    this.system.runTimeCall('info', message, handler);
}
notification.inputError = function (data, handler) {
    if (data.ids) {
        for (var key in data.ids) {
            if (data.ids.hasOwnProperty(key)) {
                var id = data.ids[key];
                var el = document.getElementById(id);
                if (!el) el = document.getElementsByName(id);
                if (el) {
                    el.className += ' error has-error';
                    var parent = $(el).parent();
                    if (parent) {
                        parent.addClass('has-error');
                    }
                }
            }
        }
    }
    this.system.runTimeCall('inputError', data.message, handler);
}
notification.showMessages = function (messages) {
    if (typeof $.notify == "undefined") {
        alert('Notifications are not included on this page! Notifications will not be displayed!');
    }
    $.each(messages, function (key, value) {
        if (value && key) {
            $.each(value, function (subKey, message) {
                notification[key](message);
            });
        }
    });
    //reset the - no, should be handled by messages themselves
    // setTimeout(function () {
    //     $('.alert').remove();
    // }, notification.config.error.duration);
}
notification.repeatMessages = function (noElMessage) {
    $('.alert').remove();
    if (this.config.infoAction) {
        this.config.infoAction = false;
        if (notification.system.getMessageCount() > 0) {
            notification.system.showBuffedMessages();
        } else {
            notification.info(noElMessage);
        }
    } else {
        this.config.infoAction = true;
    }
}
notification.promptConfInput = function (callback, question, value , yesText, noText) {
    if (typeof value === undefined || value == 'undefined') value = '';
    const check = '<input type="text" name="checkConfirm" value="' + value + '">';
    return this.promptCustom(question, check, callback, yesText, noText);
}
notification.promptConfirmation = function (question, callback, confirmation, conFunction, placeholder) {
    var check = '<label> <input type="checkbox" name="checkConfirm" value="confirmed"> ' + confirmation + '</label>';
    var call = function (value) {
        if (value !== false) {
            if (value == 'confirmed') {
                conFunction(value);
            } else {
                callback(value)
            }
        }
    };
    return this.promptCustom(question, check, call, placeholder);
}
notification.prompt = function (callback, question, placeholder) {
    vex.defaultOptions.className = 'vex-theme-top'
    vex.dialog.buttons.YES.text = output['t_ja'];
    vex.dialog.buttons.NO.text = output['t_nein'];
    vex.dialog.prompt({
        message: question,
        placeholder: placeholder,
        callback: function (value) {
            if (value)
                callback(value);
        }
    })
    return false; //compatibility with sap systems
}
notification.confirm = function (question, callback, noCallback) {
    vex.defaultOptions.className = 'vex-theme-top'
    vex.dialog.buttons.YES.text = output['t_ja'];
    vex.dialog.buttons.NO.text = output['t_nein'];
    vex.dialog.confirm({
        message: question,
        callback: function (ok) {
            if (ok) {
                callback(ok);
            } else if (noCallback) {
                noCallback(ok);
            }
        }
    });
    return false; //compatibility with sap systems
}

$(document).ready(function () {
    if (typeof baseDesign != 'undefined')
        if (baseDesign != 2017) {
            notification.config.offset = {x: 530, y: 25}
        }
    notification.system.showBuffedMessages();
});